import { Dispatch, SetStateAction } from 'react'

import { Alert } from '@interco/inter-ui/components/Alert'
import { Option } from '@interco/inter-ui/components/BottomSheet/SelectBottomSheet/types'
import { ConveniosCodes } from '@utils/enums'
import { agenciaMask } from '@utils/masks'
import { Select } from '@molecules'
import {
  buildBancosNovo,
  TiposContaNovo,
  transformBancoToOption,
  transformTipoContaToOption,
} from '@utils/transformers'
import { Banco } from '@store/refinanciamento/dadosBancarios/types'

import { DadosBancariosLocal } from './dadosBancariosForm'
import { Container, CustomInput } from './styles'

export type { DadosBancariosLocal } from './dadosBancariosForm'

interface DadosBancariosFieldsProps {
  convenioCodigo: number | string | undefined
  closeAlert: boolean
  onCloseInssAlert: () => void
  bancos: Banco[]
  localDadosBancarios: DadosBancariosLocal
  setLocalDadosBancarios: Dispatch<SetStateAction<DadosBancariosLocal>>
  isBankFieldsEditable: boolean
}

export const DadosBancariosFields = ({
  convenioCodigo,
  closeAlert,
  onCloseInssAlert,
  bancos,
  localDadosBancarios,
  setLocalDadosBancarios,
  isBankFieldsEditable,
}: DadosBancariosFieldsProps) => (
  <>
    {Number(convenioCodigo) === ConveniosCodes.INSS && !closeAlert && (
      <Alert title="" type="warning" showCloseButton onClose={onCloseInssAlert}>
        Utilize a mesma conta de recebimento do seu salário do INSS.
      </Alert>
    )}

    <Select
      key={`banco-${bancos?.length}-${localDadosBancarios.bancoSelecionado}`}
      label="Informe o banco"
      name="dropdown"
      margin="24px 0 20px 0"
      value={
        localDadosBancarios.bancoSelecionado
          ? transformBancoToOption(bancos || [], String(localDadosBancarios.bancoSelecionado))
          : { value: '', text: '' }
      }
      hideSearch={false}
      options={buildBancosNovo(bancos || [])}
      placeholder="Selecione o banco"
      onChange={(option: Option) =>
        setLocalDadosBancarios((prev) => ({
          ...prev,
          bancoSelecionado: option.value,
        }))
      }
      disabled={!isBankFieldsEditable}
      showClearIcon={false}
    />
    <Select
      label="Tipo de conta"
      name="dropdown"
      margin="0 0 20px 0"
      value={
        localDadosBancarios.tipoContaSelecionado
          ? transformTipoContaToOption(
              TiposContaNovo,
              String(localDadosBancarios.tipoContaSelecionado),
            )
          : { value: '', text: '' }
      }
      hideSearch={false}
      options={TiposContaNovo}
      placeholder="Selecione o tipo"
      onChange={(option: Option) =>
        setLocalDadosBancarios((prev) => ({
          ...prev,
          tipoContaSelecionado: option.value,
        }))
      }
      disabled={!isBankFieldsEditable}
      showClearIcon={false}
    />
    <CustomInput
      id="agencia"
      type="text"
      value={localDadosBancarios.agencia}
      label="Agência"
      placeholder="Insira a agência"
      onlyNumber
      onChange={(e) => {
        setLocalDadosBancarios({
          ...localDadosBancarios,
          agencia: agenciaMask((e.target as HTMLInputElement).value),
        })
      }}
      disabled={!isBankFieldsEditable}
    />
    <Container>
      <CustomInput
        id="conta"
        type="text"
        value={localDadosBancarios.contaDadosBancarios}
        label="Conta"
        placeholder="Insira a conta"
        onChange={(e) => {
          setLocalDadosBancarios({
            ...localDadosBancarios,
            contaDadosBancarios: (e.target as HTMLInputElement).value,
          })
        }}
        style={{ width: '45%' }}
        maxLength={11}
        onlyNumber
        disabled={!isBankFieldsEditable}
      />
      <CustomInput
        id="digito"
        type="text"
        value={localDadosBancarios.digito}
        label="Dígito"
        placeholder="Dígito"
        onlyNumber
        maxLength={1}
        onChange={(e) => {
          setLocalDadosBancarios({
            ...localDadosBancarios,
            digito: (e.target as HTMLInputElement).value,
          })
        }}
        style={{ width: '50%' }}
        disabled={!isBankFieldsEditable}
      />
    </Container>
    <Alert title="" type="grayscale">
      Caso o dígito seja X, digite 0.
    </Alert>
  </>
)
